import React, { useContext, useEffect, useState } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import breaks from 'remark-breaks';
import ReactMarkdown from 'react-markdown';
import { PartnerContext } from '../../../lib/contexts/PartnerContext';
import { UserContext } from '../../../lib/contexts/UserContext';
import { Screen } from '../../../components/Screen';

export default function CompletionScreen() {
  const { state: partner } = useContext(PartnerContext);
  const {
    state: { userObject },
  } = useContext(UserContext);

  const [shareUrl, setShareUrl] = useState('');
  const [message, setMessage] = useState(''); // start as empty string
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait until both userObject and partner are loaded (not undefined/null)
    if (!userObject || !partner || !partner.id) {
      setLoading(true);
      setMessage('');
      setShareUrl('');
      return;
    }

    // Always use /dashboard as fallback if workflowShareUrl is missing
    const url = userObject.workflowShareUrl || '/dashboard';
    setShareUrl(url);

    let msg;
    if (partner.completion_screen_content) {
      msg = partner.completion_screen_content;
    } else {
      msg =
        '# All Done!\n\nThank you for taking the Diet ID Assessment.\nPlease return this iPad to the front desk.\n\n[Start another assessment](/)';
    }

    const assessmentLink = `[Share link](${url})`;
    msg = msg.includes('[Share link]') ? msg.replace('[Share link]', assessmentLink) : msg;

    setMessage(msg);
    setLoading(false);
  }, [userObject, partner]);

  return (
    <Screen
      title={'Completion - Diet ID'}
      showSidebarNav={true}
      isAdmin={false}
      sx={{ marginLeft: '38px', border: '1px solid blue' }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={0}
        sx={{ minHeight: '40vh', maxWidth: 600, mx: 'auto' }}
      >
        <Box
          sx={{
            width: '100%',
            padding: 0,
            minHeight: 200,
          }}
        >
          {loading || !message ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
              <CircularProgress />
            </Box>
          ) : (
            <ReactMarkdown remarkPlugins={[breaks]}>{message}</ReactMarkdown>
          )}
        </Box>
      </Grid>
    </Screen>
  );
}
